<div class="access_frame">
    <div class="access_frame__inside">
        <p>{{ ".No_access" | lgTranslate }}</p>
        <button (click)="_logout()" class="button button--primary button--condensed">
            {{ ".Logout" | lgTranslate }}
        </button>
    </div>
</div>
